import React, { useContext, useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Components
import { ClickableTile, Text } from '../../../../../../../components'

// Context
import { OverlayContext } from '../../../../../../../contexts'

// Helpers
import { formatAbbrCurrency } from '../../../../../../../helpers'

// Constants
import { PANEL_IDS } from '../../../../../../../constants/overlayPanels'
import { POSSIBLE_GAIN, POSSIBLE_LOSS } from '../../../../../../../constants/indicators'

// Styles
import styles from '../../base.module.scss'

const SubTitle = ({ yearsInHome }) => (
  <Text size='s'>
    if you stayed in this home for{' '}
    <Text element='span' weight='semibold'>
      {yearsInHome} {yearsInHome === 1 ? 'year' : 'years'}
    </Text>
  </Text>
)

const HomeownerSavingsTile = ({ className, value, yearsInHome }) => {
  const { handleAddOverlay } = useContext(OverlayContext)
  const tileHeading = value < 0 ? POSSIBLE_GAIN : POSSIBLE_LOSS
  const tileValue = -value || 0

  const SubTitleComponent = useCallback(
    () => <SubTitle yearsInHome={yearsInHome}></SubTitle>,
    [yearsInHome]
  )

  return (
    <ClickableTile
      className={classnames(styles.tile, className)}
      heading={tileHeading}
      value={tileValue}
      prefix=' '
      formatter={formatAbbrCurrency}
      subTitleComponent={SubTitleComponent}
      onClick={() => handleAddOverlay(PANEL_IDS.BREAKEVEN_CHART)}
    />
  )
}

SubTitle.propTypes = {
  yearsInHome: PropTypes.number,
}
HomeownerSavingsTile.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  yearsInHome: PropTypes.number,
}

export default HomeownerSavingsTile
